import styled from 'styled-components';
import { Container } from '@material-ui/core';

const Section = styled(Container)`
  padding: 0 2rem;
  width: 100%;
  ${props => props.theme.breakpoints.up('lg')} {
    padding: 0;
  }
`;
export default Section;
